export default __webpack_public_path__ + "static/user-d13d6819ec1c57543e9be7b61b1c6c1a.png";